import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "truncated", "lineClamp", "size", "strong", "style", "xstyle"];
import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import * as stylex from '@stylexjs/stylex';
import { theme } from 'trellis-theming/modern-theme.stylex';
import { TextRoot } from '../Text/primitives';
import { DATA_COMPONENT_ATTRIBUTE } from '../../constants/dataAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const COMPONENT_NAME = 'BodyText';
export const bodyTextSizes = ['sm', 'md', 'lg'];
const strongStyle = {
  base: {
    fontWeight: "x9lwbty",
    $$css: true
  }
};

/**
 * Renders body copy, descriptions, and supporting text at sizes tuned for readability in longer passages. Used for paragraph text, UI descriptions, captions, and legal copy.
 *
 * This is the primitive version. Prefer the config API, which covers most use cases.
 *
 * @see {@link __BodyTextConfig | BodyText}
 */
export const BodyText = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = _c(20);
  let children;
  let lineClamp;
  let restProps;
  let t1;
  let t2;
  let truncated;
  let xstyle;
  if ($[0] !== t0) {
    const {
        children: t3,
        truncated: t4,
        lineClamp: t5,
        size: t6,
        strong: t7,
        xstyle: t8
      } = t0,
      t9 = _objectWithoutPropertiesLoose(t0, _excluded);
    children = t3;
    truncated = t4;
    lineClamp = t5;
    t1 = t6;
    t2 = t7;
    xstyle = t8;
    restProps = t9;
    $[0] = t0;
    $[1] = children;
    $[2] = lineClamp;
    $[3] = restProps;
    $[4] = t1;
    $[5] = t2;
    $[6] = truncated;
    $[7] = xstyle;
  } else {
    children = $[1];
    lineClamp = $[2];
    restProps = $[3];
    t1 = $[4];
    t2 = $[5];
    truncated = $[6];
    xstyle = $[7];
  }
  const size = t1 === undefined ? "md" : t1;
  const strong = t2 === undefined ? false : t2;
  const t3 = `body-${size}`;
  const t4 = strong && strongStyle.base;
  let t5;
  if ($[8] !== t4 || $[9] !== xstyle) {
    t5 = [t4, xstyle];
    $[8] = t4;
    $[9] = xstyle;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      [DATA_COMPONENT_ATTRIBUTE]: COMPONENT_NAME
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== lineClamp || $[14] !== ref || $[15] !== restProps || $[16] !== t3 || $[17] !== t5 || $[18] !== truncated) {
    t7 = /*#__PURE__*/_jsx(TextRoot, Object.assign({}, restProps, {
      ref: ref,
      truncated: truncated,
      lineClamp: lineClamp,
      variant: t3,
      xstyle: t5
    }, t6, {
      children: children
    }));
    $[12] = children;
    $[13] = lineClamp;
    $[14] = ref;
    $[15] = restProps;
    $[16] = t3;
    $[17] = t5;
    $[18] = truncated;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
});
BodyText.displayName = COMPONENT_NAME;